import { FC } from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { PaymentsFormKey } from '../MessageForms.types';

import { PaymentsQuestionForm } from './PaymentsQuestionForm';
import { PaymentsSecurityDepositReturnForm } from './PaymentsSecurityDepositReturnForm';
import { PaymentsSecurityDepositReturnMovingOutForm } from './PaymentsSecurityDepositReturnMovingOutForm';

export const paymentForms: Record<PaymentsFormKey, FC<ParsedEntry<IWidget>>> = {
  [PaymentsFormKey.PAYMENTS_SECURITY_DEPOSIT_RETURN_MOVING_OUT]:
    PaymentsSecurityDepositReturnMovingOutForm,
  [PaymentsFormKey.PAYMENTS_SECURITY_DEPOSIT_RETURN]:
    PaymentsSecurityDepositReturnForm,
  [PaymentsFormKey.PAYMENTS_QUESTION_FOR_PAYMENT]: PaymentsQuestionForm,
};
